import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EmpEmeContactType } from '../../data';

import { useSxStyles } from './useStyles';

type Props = {
  data: EmpEmeContactType;
};

export const EmergencyContactReadMode = ({ data: emp }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <div>
      <Box component="table" sx={sxStyles.table}>
        <tbody>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpEmeName')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpEmeName ? emp?.fEmpEmeName : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpEmePhone')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpEmePhone ? emp?.fEmpEmePhone : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpEmeEmail')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpEmeEmail ? emp?.fEmpEmeEmail : '')}
            </Box>
          </tr>
        </tbody>
      </Box>
    </div>
  );
};
